import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const minDate = (minDate: Date): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === undefined || control.value === null) {
      return null;
    }
    try {
      const dateInControl = new Date(control.value);
      return dateInControl >= minDate ? null : { minDate: true };
    } catch {
      return { minDateNoDate: true };
    }
  };
};
